import { FlexColumnContainer } from '@ui-components/global/CommonStyling'
import { SPACE_LARGE_PLUS } from '@ui-components/global/spacing'
import { styled } from 'styled-components'

/**
 * A flex column container with 2rem (32px) gap.
 */
export const MediumSectionContent = styled(FlexColumnContainer)`
  padding: 0;
  gap: ${SPACE_LARGE_PLUS};
  margin-bottom: 0px;
`
